export default "__VITE_ASSET__Bwv0eRxW__"